var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.518 14.78a5.579 5.579 0 0 0-6.567-.98c-.599.319-1.322-.075-1.322-.753V5.078c0-.557.258-1.094.712-1.417a5.578 5.578 0 0 1 7.177.602 5.578 5.578 0 0 1 7.176-.602c.454.323.712.86.712 1.417v7.969c0 .678-.723 1.073-1.322.753a5.579 5.579 0 0 0-6.566.98ZM3.951 17.425a5.579 5.579 0 0 1 6.567.98 5.579 5.579 0 0 1 6.566-.98M10.518 14.78V4.264"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.f3616e09a2132929bfbf99e1b787164c.svg";
export { ForwardRef as ReactComponent };